import { Action, Selector, State, StateContext } from '@ngxs/store';
import _ from 'lodash';
import { Injectable } from '@angular/core';
import { CloseDirectoryEditingList, OpenDirectoryEditingList, ToggleDirectoryEditingList } from './directory-editing-list.actions';

export interface DirectoryEditingListStateModel {
   isOpen: boolean;
}

@State<DirectoryEditingListStateModel>({
   name: 'directoryEditingList',
   defaults: {
      isOpen: false,
   },
})
@Injectable()
export class DirectoryEditingListState {
   constructor() {}

   @Selector([DirectoryEditingListState])
   public static isDirectoryEditingListOpen(state: DirectoryEditingListStateModel) {
      return state.isOpen;
   }

   @Action(OpenDirectoryEditingList)
   public openDirectoryEditingList(ctx: StateContext<DirectoryEditingListStateModel>, action: OpenDirectoryEditingList) {
      ctx.patchState({
         isOpen: true,
      });
   }

   @Action(CloseDirectoryEditingList)
   public closeDirectoryEditingList(ctx: StateContext<DirectoryEditingListStateModel>, action: CloseDirectoryEditingList) {
      ctx.patchState({
         isOpen: false,
      });
   }

   @Action(ToggleDirectoryEditingList)
   public toggleDirectoryEditingListDialog(ctx: StateContext<DirectoryEditingListStateModel>, action: ToggleDirectoryEditingList) {
      ctx.patchState({
         isOpen: !ctx.getState().isOpen,
      });
   }
}
